import { usePage } from "@inertiajs/react"

import type { SharedProps } from "@/types"

export function useTimeZone(): string {
  const { auth } = usePage<SharedProps>().props
  return (
    auth.user.tz_time_zone ?? Intl.DateTimeFormat().resolvedOptions().timeZone
  )
}
